import { FormattedMessage } from 'react-intl';
import { FaIcon } from '../../atoms/icons';
import { Button, ButtonProps } from '../../atoms/buttons';
import { styled } from '@mui/material';
import { forwardRef } from 'react';

type ClearAllFiltersButtonProps = ButtonProps & {
  localizationSubset?: string;
};

export const ClearAllFiltersButton = forwardRef<HTMLButtonElement, ClearAllFiltersButtonProps>(
  function ClearAllFiltersButton({ localizationSubset, children, ...props }, ref) {
    const localize = localizationSubset ? `${localizationSubset}.clearAllFilters.label`: `common.filters.actions.clearAllFilters.label`;
    if (!children) {
      children = <FormattedMessage id={localize} />;
    }
    return (
      <ButtonStyled variant="passive" startIcon={<FaIcon name="xmark" />} {...props} ref={ref}>
        {children}
      </ButtonStyled>
    );
  },
);

const ButtonStyled = styled(Button)(({ theme }) => ({
  ml: 'auto',
  height: '32px',
}));
